// @ts-nocheck
(function() {
  'use strict';
  if (window.__headerDrawerMegaInit) return;
  window.__headerDrawerMegaInit = true;

  const u = window.megaMenuUtils;
  if (!u) return;
  const escapeHtml = u.escapeHtml;
  const safeUrl = u.safeUrl;
  const safeImgSrc = u.safeImgSrc;
  const safeCssColor = u.safeCssColor;

  function populateMegaMenuMobile() {
    const containers = document.querySelectorAll('[data-mega-menu-mobile-container]');
    if (containers.length === 0) return;

    containers.forEach(function(container) {
      const menuHandle = container.getAttribute('data-menu-handle');
      if (!menuHandle) return;

      const megaSections = window.megaMenuConfigSections || {};
      let megaItems = [];
      let contentBlock = null;
      let banners = [];

      for (const sectionId in megaSections) {
        const section = megaSections[sectionId];
        const blocks = section.blocks || [];
        if (!contentBlock) {
          contentBlock = blocks.find(function(block) {
            const h = (block.settings && block.settings.menu_item_handle || '').toLowerCase().trim();
            return block.type === 'mega-menu-content' && h === menuHandle;
          });
        }
        const items = blocks.filter(function(block) {
          const blockHandle = (block.settings && block.settings.parent_menu_handle || '').toLowerCase().trim();
          return block.type === 'mega-menu-item' && blockHandle === menuHandle;
        });
        const sectionBanners = blocks.filter(function(block) {
          const blockHandle = (block.settings && block.settings.parent_menu_handle || '').toLowerCase().trim();
          return block.type === 'mega-menu-banner' && blockHandle === menuHandle;
        });
        megaItems = megaItems.concat(items);
        banners = banners.concat(sectionBanners);
      }

      if (megaItems.length === 0) {
        let msg = 'No items found';
        if (typeof window.megaMenuDebug === 'boolean' && window.megaMenuDebug) {
          msg += ' for handle: ' + menuHandle;
        }
        container.innerHTML = '<div style="padding: 1rem; color: var(--color-foreground-secondary);">' + escapeHtml(msg) + '</div>';
        return;
      }

      const columnHeadings = contentBlock && contentBlock.settings
        ? [contentBlock.settings.column_1_heading, contentBlock.settings.column_2_heading]
        : [];

      const itemsByColumn = {};
      megaItems.forEach(function(item) {
        const column = item.settings && item.settings.column || 1;
        if (!itemsByColumn[column]) itemsByColumn[column] = [];
        itemsByColumn[column].push(item);
      });

      for (const col in itemsByColumn) {
        itemsByColumn[col].sort(function(a, b) {
          return ((a.settings && a.settings.order) || 0) - ((b.settings && b.settings.order) || 0);
        });
      }

      const columns = Object.keys(itemsByColumn).sort(function(a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });

      const html = columns.map(function(col, colIndex) {
        const items = itemsByColumn[col];
        const heading = columnHeadings[colIndex];
        return '<div class="mega-menu-mobile-column">' +
          (heading ? '<h3 class="mega-menu-custom__column-heading">' + escapeHtml(heading) + '</h3>' : '') +
          items.map(function(item) {
            const title = escapeHtml((item.settings && item.settings.title) || '');
            const desc = escapeHtml((item.settings && item.settings.description) || '');
            const url = safeUrl(item.settings && item.settings.url || '#');
            const icon = (item.settings && item.settings.icon) || 'none';

            let iconHtml = '';
            if (icon === 'arrow') {
              iconHtml = '<svg class="mega-menu-mobile-item__icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M13.9998 4.6665L12.349 6.31734L18.8648 12.8332H4.6665V15.1665H18.8648L12.349 21.6823L13.9998 23.3332L23.3332 13.9998L13.9998 4.6665Z" fill="currentColor"/></svg>';
            } else if (icon === 'external') {
              iconHtml = '<svg class="mega-menu-mobile-item__icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M16.3333 3.5V5.83333H20.5158L9.0475 17.3017L10.6983 18.9525L22.1667 7.48417V11.6667H24.5V3.5H16.3333Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.83333 22.1667H24.5V24.5H5.83333C4.54417 24.5 3.5 23.4558 3.5 22.1667V3.5H5.83333V22.1667Z" fill="currentColor"/></svg>';
            }

            return '<a href="' + url + '" class="mega-menu-mobile-item">' +
              (iconHtml ? '<div class="mega-menu-mobile-item__icon-wrapper">' + iconHtml + '</div>' : '') +
              '<div class="mega-menu-mobile-item__text">' +
              '<span class="mega-menu-mobile-item__title">' + title + '</span>' +
              (desc ? '<span class="mega-menu-mobile-item__description">' + desc + '</span>' : '') +
              '</div>' +
              '</a>';
          }).join('') +
          '</div>';
      }).join('');

      let bannerHtml = '';
      if (banners.length > 0) {
        const banner = banners[0];
        const s = banner.settings || {};
        const imgSrc = (window.megaMenuBannerImageUrls && window.megaMenuBannerImageUrls[banner.id]) || (s.image && (typeof s.image === 'string' ? s.image : s.image.src)) || '';
        const bgColor = safeCssColor(s.background_color);
        bannerHtml = '<div class="mega-menu-banner mega-menu-banner--drawer" style="background-color:' + bgColor + '">';
        if (s.heading) {
          bannerHtml += '<h3 class="mega-menu-banner__heading">' + escapeHtml(s.heading) + '</h3>';
        }
        bannerHtml += '<div class="mega-menu-banner__article">';
        if (imgSrc) {
          const safeSrc = safeImgSrc(imgSrc);
          if (safeSrc) bannerHtml += '<div class="mega-menu-banner__image"><img src="' + safeSrc + '" alt="' + escapeHtml(s.title || '') + '" loading="lazy" class="mega-menu-banner__image-img"></div>';
        }
        bannerHtml += '<div class="mega-menu-banner__content">';
        if (s.title) bannerHtml += '<h4 class="mega-menu-banner__title">' + escapeHtml(s.title) + '</h4>';
        if (s.description) bannerHtml += '<p class="mega-menu-banner__description">' + escapeHtml(s.description) + '</p>';
        if (s.button_url && s.button_text) {
          const url = typeof s.button_url === 'string' ? s.button_url : (s.button_url.url || s.button_url.href || '#');
          bannerHtml += '<a href="' + safeUrl(url) + '" class="mega-menu-banner__cta"><span class="mega-menu-banner__cta-text">' + escapeHtml(s.button_text) + '</span><svg class="mega-menu-banner__cta-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
        }
        bannerHtml += '</div></div></div>';
      }

      container.innerHTML = html + bannerHtml;
    });
  }

  function setupMegaMenuPopulation() {
    setTimeout(populateMegaMenuMobile, 100);
    window.addEventListener('megaMenuConfigReady', function() {
      setTimeout(populateMegaMenuMobile, 100);
    });

    const megaDetails = document.querySelectorAll('[id^="Details-menu-drawer-mega-"]');
    megaDetails.forEach(function(details) {
      details.addEventListener('toggle', function() {
        if (this.hasAttribute('open')) {
          setTimeout(populateMegaMenuMobile, 50);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMegaMenuPopulation);
  } else {
    setupMegaMenuPopulation();
  }
})();
